export function capitalize(s: string): string {
  return s.slice(0, 1).toUpperCase() + s.slice(1);
}

export function isEmpty(s: string): boolean {
  return s == null || (typeof s === 'string' && s.length === 0);
}

export function isBlank(s: string): boolean {
  return s == null || (typeof s === 'string' && s.trim() === '');
}

export function isNotBlank(s: string): boolean {
  return isBlank(s) === false;
}

export function toDashCase(value: string): string {
  return value.replace(/[A-Z]/g, (value, offset) =>
    offset > 0 ? `-${value.toLowerCase()}` : value.toLowerCase()
  );
}
